var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g2, _path62, _path63, _g3, _g4, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g5, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _g6, _path78, _path79, _path80, _path81, _g7, _path82, _path83, _path84, _path85, _g8, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 369,
    viewBox: "0 0 500 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449.901 343.542H416.779V343.792H449.901V343.542Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M331.22 346.256H322.527V346.506H331.22V346.256Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M415.778 334.256H396.586V334.506H415.778V334.256Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.652 335.936H52.459V336.186H95.652V335.936Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.889 335.936H104.556V336.186H110.889V335.936Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.147 340.159H131.471V340.409H225.147V340.159Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M500 327.446H0V327.696H500V327.446Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.07 247.403V223.861L168.316 247.403V223.861L120.54 250.168V327.751H253.825V223.861L211.07 247.403ZM146.906 295.313H136.874V285.281H146.906V295.313ZM146.906 280.265H136.874V270.233H146.906V280.265ZM161.286 295.313H151.254V285.281H161.286V295.313ZM161.286 280.265H151.254V270.233H161.286V280.265ZM185.008 295.313H174.976V285.281H185.008V295.313ZM185.008 280.265H174.976V270.233H185.008V280.265ZM199.388 295.313H189.356V285.281H199.388V295.313ZM199.388 280.265H189.356V270.233H199.388V280.265ZM223.11 295.313H213.078V285.281H223.11V295.313ZM223.11 280.265H213.078V270.233H223.11V280.265ZM237.49 295.313H227.458V285.281H237.49V295.313ZM237.49 280.265H227.458V270.233H237.49V280.265Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.115 327.751H78.687L82.699 157.871H104.102L108.115 327.751Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2767 175.742L81.8237 194.921L104.74 184.896L104.296 166.109L82.2767 175.742Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3988 255.268L79.9458 274.446L106.58 262.795L106.136 244.008L80.3988 255.268Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.056 282.956L79.4598 295.028L79.0068 314.207L107.5 301.742L107.056 282.956Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3378 215.505L80.8848 234.683L105.66 223.845L105.216 205.059L81.3378 215.505Z",
    fill: "#E0E0E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M339.911 86.4042C339.911 85.2122 339.8 84.0472 339.598 82.9132L344.911 78.1161C344.519 76.9411 344.047 75.8031 343.499 74.7091L336.351 75.0742C335.009 73.1511 333.337 71.4791 331.414 70.1371L331.779 62.9892C330.685 62.4412 329.547 61.9701 328.372 61.5771L323.576 66.8902C322.442 66.6882 321.277 66.5771 320.085 66.5771C318.893 66.5771 317.728 66.6882 316.594 66.8902L311.798 61.5771C310.623 61.9691 309.485 62.4412 308.391 62.9892L308.756 70.1371C306.833 71.4791 305.16 73.1522 303.819 75.0742L296.671 74.7091C296.123 75.8031 295.651 76.9411 295.259 78.1161L300.572 82.9132C300.37 84.0472 300.259 85.2122 300.259 86.4042C300.259 87.5962 300.37 88.7612 300.572 89.8962L295.259 94.6921C295.651 95.8671 296.123 97.0051 296.671 98.0991L303.819 97.7342C305.161 99.6572 306.834 101.33 308.756 102.671L308.391 109.819C309.485 110.367 310.623 110.839 311.798 111.231L316.594 105.918C317.728 106.12 318.893 106.231 320.085 106.231C321.277 106.231 322.442 106.12 323.576 105.918L328.373 111.231C329.548 110.839 330.686 110.367 331.78 109.819L331.415 102.671C333.338 101.329 335.01 99.6562 336.352 97.7342L343.5 98.0991C344.048 97.0051 344.52 95.8671 344.912 94.6921L339.599 89.8962C339.8 88.7612 339.911 87.5962 339.911 86.4042ZM320.084 97.6451C313.876 97.6451 308.843 92.6122 308.843 86.4042C308.843 80.1962 313.876 75.1632 320.084 75.1632C326.292 75.1632 331.325 80.1962 331.325 86.4042C331.325 92.6122 326.292 97.6451 320.084 97.6451Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M437.147 98.2865C437.147 97.5535 437.079 96.8365 436.955 96.1395L440.222 93.1895C439.981 92.4665 439.691 91.7675 439.354 91.0945L434.958 91.3195C434.133 90.1375 433.104 89.1085 431.922 88.2835L432.146 83.8875C431.473 83.5505 430.773 83.2605 430.051 83.0195L427.102 86.2865C426.405 86.1625 425.688 86.0945 424.955 86.0945C424.222 86.0945 423.505 86.1625 422.808 86.2865L419.859 83.0195C419.136 83.2605 418.437 83.5505 417.764 83.8875L417.988 88.2835C416.806 89.1085 415.777 90.1375 414.952 91.3195L410.556 91.0945C410.219 91.7675 409.929 92.4675 409.688 93.1895L412.955 96.1395C412.831 96.8365 412.763 97.5535 412.763 98.2865C412.763 99.0195 412.831 99.7365 412.955 100.434L409.688 103.384C409.929 104.107 410.219 104.806 410.556 105.479L414.952 105.254C415.777 106.436 416.806 107.465 417.988 108.29L417.764 112.686C418.437 113.023 419.137 113.313 419.859 113.554L422.809 110.287C423.506 110.411 424.223 110.479 424.956 110.479C425.689 110.479 426.406 110.411 427.103 110.287L430.052 113.554C430.775 113.313 431.474 113.023 432.147 112.686L431.923 108.29C433.105 107.465 434.134 106.436 434.959 105.254L439.355 105.479C439.692 104.806 439.982 104.106 440.223 103.384L436.956 100.434C437.078 99.7365 437.147 99.0195 437.147 98.2865Z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M407.021 72.236C407.021 70.536 406.863 68.875 406.575 67.257L414.151 60.418C413.592 58.742 412.919 57.12 412.138 55.559L401.945 56.08C400.032 53.338 397.647 50.953 394.905 49.04L395.426 38.847C393.866 38.066 392.243 37.393 390.567 36.834L383.728 44.41C382.111 44.122 380.449 43.964 378.749 43.964C377.049 43.964 375.388 44.122 373.771 44.41L366.931 36.834C365.255 37.393 363.633 38.066 362.073 38.847L362.594 49.04C359.852 50.953 357.467 53.339 355.554 56.08L345.361 55.559C344.58 57.12 343.907 58.742 343.348 60.418L350.924 67.257C350.637 68.874 350.478 70.536 350.478 72.236C350.478 73.936 350.636 75.597 350.924 77.215L343.348 84.055C343.907 85.731 344.58 87.353 345.361 88.913L355.554 88.392C357.467 91.134 359.852 93.519 362.594 95.432L362.073 105.625C363.633 106.406 365.256 107.079 366.932 107.638L373.772 100.062C375.389 100.35 377.051 100.508 378.75 100.508C380.449 100.508 382.111 100.35 383.729 100.062L390.568 107.638C392.244 107.079 393.866 106.406 395.427 105.625L394.906 95.432C397.648 93.519 400.033 91.134 401.946 88.392L412.139 88.913C412.92 87.353 413.593 85.73 414.152 84.055L406.576 77.215C406.863 75.597 407.021 73.936 407.021 72.236ZM378.749 88.265C369.897 88.265 362.72 81.089 362.72 72.236C362.72 63.384 369.897 56.207 378.749 56.207C387.602 56.207 394.778 63.384 394.778 72.236C394.778 81.088 387.602 88.265 378.749 88.265Z",
    fill: "#F5F5F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M411.446 240.117L408.549 327.751H416.154L413.257 240.117H411.446Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M411.538 259.287C411.538 259.287 369.85 300.577 379.376 312.995C381.92 316.312 395.457 308.415 395.457 308.415C395.457 308.415 397.943 315.826 400.193 316.325C404.364 317.25 414.348 306.749 414.348 306.749C414.348 306.749 422.61 316.886 426.422 316.325C429.307 315.9 433.083 306.749 433.083 306.749C433.083 306.749 445.327 314.813 447.655 311.745C457.28 299.061 411.538 259.287 411.538 259.287Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M411.793 237.128C411.793 237.128 375.592 272.984 383.863 283.767C386.072 286.647 397.828 279.79 397.828 279.79C397.828 279.79 399.987 286.226 401.94 286.659C405.562 287.462 414.233 278.343 414.233 278.343C414.233 278.343 421.408 287.146 424.718 286.659C427.223 286.29 430.503 278.343 430.503 278.343C430.503 278.343 441.136 285.346 443.157 282.682C451.515 271.668 411.793 237.128 411.793 237.128Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M412.104 221.225C412.104 221.225 382.602 250.445 389.343 259.233C391.143 261.58 400.723 255.992 400.723 255.992C400.723 255.992 402.482 261.237 404.075 261.59C407.027 262.245 414.093 254.813 414.093 254.813C414.093 254.813 419.94 261.987 422.637 261.59C424.679 261.289 427.351 254.813 427.351 254.813C427.351 254.813 436.016 260.52 437.663 258.349C444.475 249.372 412.104 221.225 412.104 221.225Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M417.105 211.426C414.495 208.921 410.333 209.058 407.895 211.73C401.196 219.074 389.717 232.989 393.702 238.185C395.177 240.108 403.027 235.53 403.027 235.53C403.027 235.53 404.468 239.827 405.773 240.117C408.192 240.653 413.981 234.564 413.981 234.564C413.981 234.564 418.772 240.442 420.982 240.117C422.655 239.871 424.845 234.564 424.845 234.564C424.845 234.564 431.945 239.24 433.295 237.461C437.349 232.118 424.459 218.485 417.105 211.426Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M320.081 203.528L315.975 327.751H326.754L322.648 203.528H320.081Z",
    fill: "#E0E0E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M320.212 230.703C320.212 230.703 261.119 289.232 274.622 306.835C278.228 311.537 297.417 300.343 297.417 300.343C297.417 300.343 300.94 310.849 304.13 311.556C310.043 312.868 324.196 297.982 324.196 297.982C324.196 297.982 335.908 312.352 341.311 311.556C345.401 310.954 350.754 297.982 350.754 297.982C350.754 297.982 368.11 309.413 371.41 305.064C385.052 287.083 320.212 230.703 320.212 230.703Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M320.573 199.292C320.573 199.292 269.257 250.118 280.983 265.404C284.115 269.487 300.778 259.767 300.778 259.767C300.778 259.767 303.838 268.89 306.608 269.504C311.742 270.643 324.033 257.716 324.033 257.716C324.033 257.716 334.204 270.195 338.895 269.504C342.447 268.981 347.095 257.716 347.095 257.716C347.095 257.716 362.167 267.643 365.032 263.866C376.879 248.252 320.573 199.292 320.573 199.292Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M321.014 176.748C321.014 176.748 279.195 218.168 288.75 230.625C291.302 233.952 304.882 226.031 304.882 226.031C304.882 226.031 307.375 233.466 309.633 233.966C313.817 234.894 323.833 224.36 323.833 224.36C323.833 224.36 332.122 234.529 335.945 233.966C338.839 233.54 342.627 224.36 342.627 224.36C342.627 224.36 354.91 232.45 357.245 229.372C366.9 216.647 321.014 176.748 321.014 176.748Z",
    fill: "#F0F0F0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M328.103 162.859C324.404 159.308 318.503 159.502 315.047 163.29C305.551 173.7 289.279 193.425 294.929 200.791C297.02 203.517 308.147 197.027 308.147 197.027C308.147 197.027 310.19 203.119 312.04 203.529C315.468 204.29 323.675 195.658 323.675 195.658C323.675 195.658 330.466 203.99 333.599 203.529C335.97 203.18 339.074 195.658 339.074 195.658C339.074 195.658 349.138 202.286 351.051 199.764C356.798 192.19 338.528 172.864 328.103 162.859Z",
    fill: "#F5F5F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M250 368.762C358.53 368.762 446.512 363.693 446.512 357.439C446.512 351.186 358.53 346.116 250 346.116C141.469 346.116 53.4878 351.186 53.4878 357.439C53.4878 363.693 141.469 368.762 250 368.762Z",
    fill: "#E9F3F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M203.733 78.9423C206.561 44.789 181.166 14.8104 147.013 11.9831C112.859 9.15585 82.8806 34.5506 80.0533 68.7039C77.226 102.857 102.621 132.836 136.774 135.663C170.927 138.49 200.906 113.096 203.733 78.9423Z",
    fill: "url(#paint0_linear_763_11589)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.733 78.9423C206.561 44.789 181.166 14.8104 147.013 11.9831C112.859 9.15585 82.8806 34.5506 80.0533 68.7039C77.226 102.857 102.621 132.836 136.774 135.663C170.927 138.49 200.906 113.096 203.733 78.9423Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M159.591 93.6155C159.106 93.6675 158.625 93.4855 158.295 93.1255L156.458 91.1225C156.186 90.8265 155.809 90.6485 155.408 90.6265L152.993 90.4955C152.816 90.4855 152.642 90.4455 152.479 90.3775L149.299 89.0376C148.962 88.8956 148.585 88.8785 148.237 88.9885L145.451 89.8716C145.299 89.9196 145.139 89.9445 144.98 89.9435L141.87 89.9305C141.454 89.9285 141.055 90.0955 140.764 90.3925L138.114 93.0985C137.889 93.3285 137.598 93.4816 137.281 93.5376L135.775 93.8015C135.297 93.8855 134.807 93.7385 134.453 93.4055L133.61 92.6095L132.658 90.2085C132.576 90.0015 132.357 89.8845 132.139 89.9325L130.157 90.3665C129.792 90.4465 129.492 90.0745 129.648 89.7345L130.298 87.6555L130.263 85.2896L129.556 85.0495L125.725 88.7206C125.243 89.1566 124.469 88.8775 124.376 88.2345L123.639 83.1615C123.54 82.4815 123.998 81.8446 124.675 81.7225L126.426 81.4065C126.808 81.3375 127.138 81.0985 127.322 80.7565C127.641 80.1645 128.365 79.9226 128.976 80.2016L131.883 81.5315C132.013 81.5915 132.153 81.6285 132.295 81.6415L133.346 81.7395C134.215 81.8205 134.907 81.0246 134.706 80.1756L134.324 78.5616C134.251 78.2536 134.295 77.9286 134.448 77.6516L136.715 73.5385C136.741 73.4915 136.764 73.4425 136.784 73.3915L138.218 69.7675C138.273 69.6295 138.351 69.5025 138.449 69.3915L141.029 66.4775L142.187 63.6125L148.673 60.4855L147.091 59.3046L146.883 58.3035C146.669 57.2715 147.11 56.2145 147.993 55.6405L149.915 54.3915C151.133 53.5995 151.447 51.9535 150.606 50.7685L148.46 47.4055C148.125 46.8815 147.611 46.4965 147.013 46.3245L145.135 45.7835C144.978 45.7385 144.825 45.6775 144.679 45.6035L141.32 43.8865C140.115 43.2705 138.638 43.7005 137.952 44.8675L136.58 47.2015C136.548 47.2555 136.518 47.3115 136.49 47.3685L135.22 49.9515C134.609 51.1945 133.118 51.7245 131.859 51.1465L131.569 51.0135C131.459 50.9625 131.352 50.9045 131.25 50.8385L128.889 49.3165C127.625 48.5015 127.334 46.7775 128.26 45.5925L129.141 44.4655C129.233 44.3475 129.335 44.2386 129.446 44.1385L132.26 41.6095L133.74 40.1675C133.902 40.0095 134.084 39.8745 134.282 39.7645L135.205 39.2515C136.223 38.6855 136.73 37.5035 136.439 36.3755L136.207 35.4775C135.926 34.3905 134.969 33.6145 133.847 33.5635L133.074 33.5285C132.84 33.5175 132.608 33.4755 132.385 33.4015L131.003 32.9436C130.156 32.6626 129.224 32.8435 128.544 33.4215L126.891 34.8245C126.412 35.2315 125.799 35.4475 125.171 35.4315L120.026 35.2985C119.852 35.2945 119.678 35.2715 119.509 35.2315L114.303 34.0115C113.987 33.9375 113.659 33.9245 113.338 33.9725L105.58 35.1425C105.195 35.2005 104.801 35.1695 104.429 35.0525L101.018 33.9755C100.578 33.8365 100.109 33.8195 99.6601 33.9255L98.3501 34.2356C97.5401 34.4266 96.8741 35.0005 96.5651 35.7725L91.5061 48.3965C91.4071 48.6445 91.3471 48.9065 91.3291 49.1725L90.7941 56.9765C90.7901 57.0325 90.7881 57.0885 90.7881 57.1445L90.7781 61.2076C90.6901 61.8545 91.5681 62.1355 91.8731 61.5585L94.3351 56.8995C94.4451 56.6915 94.5831 56.4995 94.7461 56.3285L95.0001 56.0665C96.2441 54.7625 98.4101 55.1205 99.1691 56.7555L102.405 63.7295L104.285 65.1915L103.127 74.2665C103.1 74.4815 103.127 74.7005 103.208 74.9025L106.29 82.5956C106.371 82.7966 106.501 82.9745 106.67 83.1115L114.259 89.2805L117.592 93.4146L123.608 93.9256L126.147 94.3145L129.134 94.5845L131.722 95.8425L134.273 96.9106L134.769 96.8015C135.699 96.5965 136.589 97.2775 136.636 98.2275L136.671 98.9445C136.679 99.1165 136.659 99.2895 136.61 99.4545L135.7 102.547C135.571 102.985 135.643 103.458 135.898 103.838L137.832 106.725C137.88 106.796 137.933 106.863 137.992 106.925L141.333 110.462C141.53 110.671 141.782 110.821 142.061 110.894L143.974 111.396C144.567 111.552 145.012 112.045 145.104 112.652L145.496 115.22L145.932 118.757C145.939 118.811 145.948 118.865 145.961 118.918L146.963 123.225C146.975 123.278 146.991 123.331 147.009 123.383L147.481 124.738C147.594 125.062 147.812 125.338 148.1 125.524L148.691 125.905C148.979 126.091 149.321 126.175 149.663 126.144L151.662 125.964C152.68 125.872 153.328 124.831 152.959 123.877C152.908 123.745 152.875 123.606 152.862 123.465L152.796 122.759C152.769 122.467 152.826 122.174 152.959 121.914L153.831 120.217C153.968 119.95 154.181 119.729 154.442 119.581L155.447 119.013C155.647 118.9 155.819 118.744 155.95 118.555L157.031 117.009C157.062 116.964 157.096 116.92 157.133 116.879L158.545 115.261C158.592 115.207 158.636 115.149 158.675 115.088L160.129 112.852C160.227 112.701 160.298 112.533 160.339 112.357L160.841 110.172C160.915 109.852 161.089 109.563 161.338 109.349L164.389 106.729C164.62 106.531 164.786 106.269 164.868 105.976L166.735 99.2995C166.762 99.2015 166.8 99.1055 166.846 99.0145L166.884 98.9395C166.942 98.8265 166.985 98.7065 167.013 98.5835L167.506 96.4256C167.672 95.6966 167.29 94.9536 166.6 94.6646L166.511 94.6275C164.326 93.7135 161.946 93.3655 159.591 93.6155ZM91.4201 58.4105L91.4071 58.3845L91.4241 58.4105H91.4201Z",
    fill: "url(#paint1_linear_763_11589)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.224 22.1318L174.237 22.6498C173.893 23.0288 173.388 23.2198 172.879 23.1648L166.697 22.4858C166.454 22.4588 166.209 22.4888 165.979 22.5718L161.484 24.1968C161.332 24.2518 161.189 24.3298 161.06 24.4278L159.306 25.7618C158.395 26.4548 158.486 27.8518 159.479 28.4218L160.522 29.0198C160.585 29.0558 160.645 29.0958 160.703 29.1398L165.935 33.1708C166.329 33.4748 166.559 33.9438 166.558 34.4418L166.546 39.1798C166.545 39.6318 166.735 40.0628 167.069 40.3668L172.732 45.5168C173.56 46.2698 174.885 45.9618 175.295 44.9208L175.423 44.5948C175.543 44.2888 175.755 44.0278 176.029 43.8478L181.902 39.9678C181.923 39.9538 181.944 39.9428 181.967 39.9328L187.54 37.5218C187.708 37.4488 187.81 37.2768 187.793 37.0938C187.752 36.6598 188.315 36.4558 188.562 36.8148C188.562 36.8148 191.492 39.7788 190.895 40.7558C190.856 40.8198 187.367 42.4728 187.367 42.4728C187.004 42.6558 187.084 43.1958 187.484 43.2668C187.484 43.2668 192.012 43.3958 193.156 44.2698C194.625 45.3928 196.312 50.9598 196.312 50.9598C196.389 51.1308 196.345 51.3318 196.203 51.4548L195.947 51.6758C195.923 51.6958 195.898 51.7138 195.87 51.7288L195.675 51.8328C195.454 51.9508 195.384 52.2328 195.523 52.4408L197.527 55.4358C197.55 55.4698 197.567 55.5058 197.579 55.5448L198.806 59.4688H198.804L196.536 62.0688C196.45 62.1678 196.415 62.3008 196.44 62.4288L197.544 67.9758C197.566 68.0858 197.543 68.1988 197.481 68.2918C197.481 68.2918 193.503 69.9078 194.292 74.0138C194.718 76.2328 201.049 77.5778 203.792 78.0588C203.886 76.6578 203.939 75.2458 203.939 73.8218C203.941 52.2488 192.93 33.2508 176.224 22.1318Z",
    fill: "url(#paint2_linear_763_11589)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.591 93.6155C159.106 93.6675 158.625 93.4855 158.295 93.1255L156.458 91.1225C156.186 90.8265 155.809 90.6485 155.408 90.6265L152.993 90.4955C152.816 90.4855 152.642 90.4455 152.479 90.3775L149.299 89.0376C148.962 88.8956 148.585 88.8785 148.237 88.9885L145.451 89.8716C145.299 89.9196 145.139 89.9445 144.98 89.9435L141.87 89.9305C141.454 89.9285 141.055 90.0955 140.764 90.3925L138.114 93.0985C137.889 93.3285 137.598 93.4816 137.281 93.5376L135.775 93.8015C135.297 93.8855 134.807 93.7385 134.453 93.4055L133.61 92.6095L132.658 90.2085C132.576 90.0015 132.357 89.8845 132.139 89.9325L130.157 90.3665C129.792 90.4465 129.492 90.0745 129.648 89.7345L130.298 87.6555L130.263 85.2896L129.556 85.0495L125.725 88.7206C125.243 89.1566 124.469 88.8775 124.376 88.2345L123.639 83.1615C123.54 82.4815 123.998 81.8446 124.675 81.7225L126.426 81.4065C126.808 81.3375 127.138 81.0985 127.322 80.7565C127.641 80.1645 128.365 79.9226 128.976 80.2016L131.883 81.5315C132.013 81.5915 132.153 81.6285 132.295 81.6415L133.346 81.7395C134.215 81.8205 134.907 81.0246 134.706 80.1756L134.324 78.5616C134.251 78.2536 134.295 77.9286 134.448 77.6516L136.715 73.5385C136.741 73.4915 136.764 73.4425 136.784 73.3915L138.218 69.7675C138.273 69.6295 138.351 69.5025 138.449 69.3915L141.029 66.4775L142.187 63.6125L148.673 60.4855L147.091 59.3046L146.883 58.3035C146.669 57.2715 147.11 56.2145 147.993 55.6405L149.915 54.3915C151.133 53.5995 151.447 51.9535 150.606 50.7685L148.46 47.4055C148.125 46.8815 147.611 46.4965 147.013 46.3245L145.135 45.7835C144.978 45.7385 144.825 45.6775 144.679 45.6035L141.32 43.8865C140.115 43.2705 138.638 43.7005 137.952 44.8675L136.58 47.2015C136.548 47.2555 136.518 47.3115 136.49 47.3685L135.22 49.9515C134.609 51.1945 133.118 51.7245 131.859 51.1465L131.569 51.0135C131.459 50.9625 131.352 50.9045 131.25 50.8385L128.889 49.3165C127.625 48.5015 127.334 46.7775 128.26 45.5925L129.141 44.4655C129.233 44.3475 129.335 44.2386 129.446 44.1385L132.26 41.6095L133.74 40.1675C133.902 40.0095 134.084 39.8745 134.282 39.7645L135.205 39.2515C136.223 38.6855 136.73 37.5035 136.439 36.3755L136.207 35.4775C135.926 34.3905 134.969 33.6145 133.847 33.5635L133.074 33.5285C132.84 33.5175 132.608 33.4755 132.385 33.4015L131.003 32.9436C130.156 32.6626 129.224 32.8435 128.544 33.4215L126.891 34.8245C126.412 35.2315 125.799 35.4475 125.171 35.4315L120.026 35.2985C119.852 35.2945 119.678 35.2715 119.509 35.2315L114.303 34.0115C113.987 33.9375 113.659 33.9245 113.338 33.9725L105.58 35.1425C105.195 35.2005 104.801 35.1695 104.429 35.0525L101.018 33.9755C100.578 33.8365 100.109 33.8195 99.6601 33.9255L98.3501 34.2356C97.5401 34.4266 96.8741 35.0005 96.5651 35.7725L91.5061 48.3965C91.4071 48.6445 91.3471 48.9065 91.3291 49.1725L90.7941 56.9765C90.7901 57.0325 90.7881 57.0885 90.7881 57.1445L90.7781 61.2076C90.6901 61.8545 91.5681 62.1355 91.8731 61.5585L94.3351 56.8995C94.4451 56.6915 94.5831 56.4995 94.7461 56.3285L95.0001 56.0665C96.2441 54.7625 98.4101 55.1205 99.1691 56.7555L102.405 63.7295L104.285 65.1915L103.127 74.2665C103.1 74.4815 103.127 74.7005 103.208 74.9025L106.29 82.5956C106.371 82.7966 106.501 82.9745 106.67 83.1115L114.259 89.2805L117.592 93.4146L123.608 93.9256L126.147 94.3145L129.134 94.5845L131.722 95.8425L134.273 96.9106L134.769 96.8015C135.699 96.5965 136.589 97.2775 136.636 98.2275L136.671 98.9445C136.679 99.1165 136.659 99.2895 136.61 99.4545L135.7 102.547C135.571 102.985 135.643 103.458 135.898 103.838L137.832 106.725C137.88 106.796 137.933 106.863 137.992 106.925L141.333 110.462C141.53 110.671 141.782 110.821 142.061 110.894L143.974 111.396C144.567 111.552 145.012 112.045 145.104 112.652L145.496 115.22L145.932 118.757C145.939 118.811 145.948 118.865 145.961 118.918L146.963 123.225C146.975 123.278 146.991 123.331 147.009 123.383L147.481 124.738C147.594 125.062 147.812 125.338 148.1 125.524L148.691 125.905C148.979 126.091 149.321 126.175 149.663 126.144L151.662 125.964C152.68 125.872 153.328 124.831 152.959 123.877C152.908 123.745 152.875 123.606 152.862 123.465L152.796 122.759C152.769 122.467 152.826 122.174 152.959 121.914L153.831 120.217C153.968 119.95 154.181 119.729 154.442 119.581L155.447 119.013C155.647 118.9 155.819 118.744 155.95 118.555L157.031 117.009C157.062 116.964 157.096 116.92 157.133 116.879L158.545 115.261C158.592 115.207 158.636 115.149 158.675 115.088L160.129 112.852C160.227 112.701 160.298 112.533 160.339 112.357L160.841 110.172C160.915 109.852 161.089 109.563 161.338 109.349L164.389 106.729C164.62 106.531 164.786 106.269 164.868 105.976L166.735 99.2995C166.762 99.2015 166.8 99.1055 166.846 99.0145L166.884 98.9395C166.942 98.8265 166.985 98.7065 167.013 98.5835L167.506 96.4256C167.672 95.6966 167.29 94.9536 166.6 94.6646L166.511 94.6275C164.326 93.7135 161.946 93.3655 159.591 93.6155ZM91.4201 58.4105L91.4071 58.3845L91.4241 58.4105H91.4201Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.224 22.1318L174.237 22.6498C173.893 23.0288 173.388 23.2198 172.879 23.1648L166.697 22.4858C166.454 22.4588 166.209 22.4888 165.979 22.5718L161.484 24.1968C161.332 24.2518 161.189 24.3298 161.06 24.4278L159.306 25.7618C158.395 26.4548 158.486 27.8518 159.479 28.4218L160.522 29.0198C160.585 29.0558 160.645 29.0958 160.703 29.1398L165.935 33.1708C166.329 33.4748 166.559 33.9438 166.558 34.4418L166.546 39.1798C166.545 39.6318 166.735 40.0628 167.069 40.3668L172.732 45.5168C173.56 46.2698 174.885 45.9618 175.295 44.9208L175.423 44.5948C175.543 44.2888 175.755 44.0278 176.029 43.8478L181.902 39.9678C181.923 39.9538 181.944 39.9428 181.967 39.9328L187.54 37.5218C187.708 37.4488 187.81 37.2768 187.793 37.0938C187.752 36.6598 188.315 36.4558 188.562 36.8148C188.562 36.8148 191.492 39.7788 190.895 40.7558C190.856 40.8198 187.367 42.4728 187.367 42.4728C187.004 42.6558 187.084 43.1958 187.484 43.2668C187.484 43.2668 192.012 43.3958 193.156 44.2698C194.625 45.3928 196.312 50.9598 196.312 50.9598C196.389 51.1308 196.345 51.3318 196.203 51.4548L195.947 51.6758C195.923 51.6958 195.898 51.7138 195.87 51.7288L195.675 51.8328C195.454 51.9508 195.384 52.2328 195.523 52.4408L197.527 55.4358C197.55 55.4698 197.567 55.5058 197.579 55.5448L198.806 59.4688H198.804L196.536 62.0688C196.45 62.1678 196.415 62.3008 196.44 62.4288L197.544 67.9758C197.566 68.0858 197.543 68.1988 197.481 68.2918C197.481 68.2918 193.503 69.9078 194.292 74.0138C194.718 76.2328 201.049 77.5778 203.792 78.0588C203.886 76.6578 203.939 75.2458 203.939 73.8218C203.941 52.2488 192.93 33.2508 176.224 22.1318Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M176.656 199.649H172.43L168.256 354.548C168.212 356.184 169.526 357.534 171.162 357.534H177.923C179.559 357.534 180.874 356.184 180.83 354.548L176.656 199.649Z",
    fill: "url(#paint3_linear_763_11589)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.656 199.649H172.43L168.256 354.548C168.212 356.184 169.526 357.534 171.162 357.534H177.923C179.559 357.534 180.874 356.184 180.83 354.548L176.656 199.649Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M188.445 195.202L182.52 194.924L181.939 193.18C181.541 191.986 180.471 191.144 179.217 191.037L175.529 190.722C174.213 190.61 172.967 191.33 172.407 192.525L171.521 194.417C169.399 194.368 167.639 196.068 167.639 198.202C167.639 200.367 169.448 202.094 171.611 201.992L188.445 201.203C190.048 201.128 191.309 199.806 191.309 198.202C191.308 196.598 190.047 195.277 188.445 195.202Z",
    fill: "url(#paint4_linear_763_11589)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M188.445 195.202L182.52 194.924L181.939 193.18C181.541 191.986 180.471 191.144 179.217 191.037L175.529 190.722C174.213 190.61 172.967 191.33 172.407 192.525L171.521 194.417C169.399 194.368 167.639 196.068 167.639 198.202C167.639 200.367 169.448 202.094 171.611 201.992L188.445 201.203C190.048 201.128 191.309 199.806 191.309 198.202C191.308 196.598 190.047 195.277 188.445 195.202Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M188.445 201.204C189.516 201.154 190.423 200.542 190.915 199.666L175.127 199.882C175.38 199.374 175.535 198.808 175.535 198.201C175.535 196.051 173.75 194.338 171.607 194.413C169.446 194.314 167.639 196.039 167.639 198.203C167.639 200.368 169.448 202.095 171.611 201.993L188.445 201.204Z",
    fill: "#001F23"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M170.627 197.118C169.584 197.118 168.738 196.272 168.738 195.229V152.576C168.738 149.861 170.939 147.659 173.655 147.659C176.647 147.659 178.945 150.308 178.522 153.27L172.497 195.495C172.365 196.426 171.568 197.118 170.627 197.118Z",
    fill: "url(#paint5_linear_763_11589)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.627 197.118C169.584 197.118 168.738 196.272 168.738 195.229V152.576C168.738 149.861 170.939 147.659 173.655 147.659C176.647 147.659 178.945 150.308 178.522 153.27L172.497 195.495C172.365 196.426 171.568 197.118 170.627 197.118Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M174.12 147.684C173.966 147.67 173.812 147.658 173.654 147.658C170.939 147.658 168.737 149.859 168.737 152.575V195.228C168.737 195.634 168.868 196.007 169.085 196.315C169.759 196.099 170.278 195.521 170.382 194.788L176.406 152.562C176.695 150.545 175.718 148.673 174.12 147.684Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M171.821 199.1C171.274 199.989 171.551 201.152 172.44 201.699L208.769 224.049C211.082 225.472 214.11 224.75 215.533 222.438C217.101 219.89 216.048 216.544 213.304 215.352L174.183 198.358C173.32 197.983 172.314 198.299 171.821 199.1Z",
    fill: "url(#paint6_linear_763_11589)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M171.821 199.1C171.274 199.989 171.551 201.152 172.44 201.699L208.769 224.049C211.082 225.472 214.11 224.75 215.533 222.438C217.101 219.89 216.048 216.544 213.304 215.352L174.183 198.358C173.32 197.983 172.314 198.299 171.821 199.1Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M213.304 215.352L174.183 198.358C173.523 198.072 172.781 198.192 172.247 198.621C172.336 199.137 172.631 199.614 173.112 199.91L209.441 222.26C211.747 223.679 214.764 222.964 216.192 220.666C216.547 218.517 215.443 216.281 213.304 215.352Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M169.063 199.1C169.61 199.989 169.333 201.152 168.444 201.699L132.115 224.049C129.802 225.472 126.774 224.75 125.351 222.438C123.783 219.89 124.836 216.544 127.58 215.352L166.701 198.358C167.564 197.983 168.57 198.299 169.063 199.1Z",
    fill: "url(#paint7_linear_763_11589)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.063 199.1C169.61 199.989 169.333 201.152 168.444 201.699L132.115 224.049C129.802 225.472 126.774 224.75 125.351 222.438C123.783 219.89 124.836 216.544 127.58 215.352L166.701 198.358C167.564 197.983 168.57 198.299 169.063 199.1Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M166.701 198.357L127.58 215.351C125.177 216.395 124.071 219.09 124.886 221.455C126.452 223.107 129.01 223.498 131.027 222.258L167.356 199.908C167.91 199.567 168.226 198.987 168.253 198.383C167.776 198.161 167.214 198.135 166.701 198.357Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.113 248.521L171.088 249.438C172.365 249.549 173.61 249.596 174.608 249.596C175.572 249.596 176.767 249.551 177.998 249.447L177.973 248.533C176.968 248.618 175.85 248.671 174.608 248.671C173.314 248.67 172.152 248.613 171.113 248.521Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.212 257.368L178.062 251.796C177.069 251.89 175.921 251.951 174.609 251.951C173.235 251.951 172.053 251.881 171.026 251.779L170.875 257.363C172.119 257.464 173.388 257.508 174.608 257.508C175.788 257.508 177.009 257.463 178.212 257.368Z",
    fill: "#001F23"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M112.363 155.156H106.931L101.565 354.279C101.508 356.382 103.197 358.117 105.301 358.117H113.993C116.097 358.117 117.786 356.382 117.729 354.279L112.363 155.156Z",
    fill: "url(#paint8_linear_763_11589)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.363 155.156H106.931L101.565 354.279C101.508 356.382 103.197 358.117 105.301 358.117H113.993C116.097 358.117 117.786 356.382 117.729 354.279L112.363 155.156Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M127.517 149.439L119.9 149.082L119.153 146.841C118.641 145.306 117.266 144.223 115.654 144.085L110.913 143.68C109.222 143.535 107.62 144.461 106.9 145.998L105.761 148.431C103.033 148.368 100.77 150.553 100.77 153.297C100.77 156.081 103.096 158.3 105.876 158.17L127.517 157.155C129.578 157.059 131.198 155.36 131.198 153.297C131.199 151.235 129.578 149.536 127.517 149.439Z",
    fill: "url(#paint9_linear_763_11589)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.517 149.439L119.9 149.082L119.153 146.841C118.641 145.306 117.266 144.223 115.654 144.085L110.913 143.68C109.222 143.535 107.62 144.461 106.9 145.998L105.761 148.431C103.033 148.368 100.77 150.553 100.77 153.297C100.77 156.081 103.096 158.3 105.876 158.17L127.517 157.155C129.578 157.059 131.198 155.36 131.198 153.297C131.199 151.235 129.578 149.536 127.517 149.439Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.517 157.155C128.893 157.091 130.06 156.303 130.692 155.178L110.396 155.455C110.721 154.802 110.92 154.075 110.92 153.293C110.92 150.529 108.626 148.327 105.871 148.423C103.092 148.295 100.77 150.513 100.77 153.295C100.77 156.079 103.096 158.298 105.876 158.168L127.517 157.155Z",
    fill: "#001F23"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M104.613 151.903C103.272 151.903 102.184 150.816 102.184 149.474V94.6433C102.184 91.1523 105.014 88.3223 108.505 88.3223C112.351 88.3223 115.305 91.7283 114.762 95.5353L107.018 149.816C106.847 151.013 105.822 151.903 104.613 151.903Z",
    fill: "url(#paint10_linear_763_11589)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.613 151.903C103.272 151.903 102.184 150.816 102.184 149.474V94.6433C102.184 91.1523 105.014 88.3223 108.505 88.3223C112.351 88.3223 115.305 91.7283 114.762 95.5353L107.018 149.816C106.847 151.013 105.822 151.903 104.613 151.903Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M109.104 88.3553C108.906 88.3363 108.708 88.3223 108.505 88.3223C105.015 88.3223 102.185 91.1523 102.185 94.6423V149.473C102.185 149.994 102.353 150.475 102.632 150.87C103.498 150.593 104.165 149.849 104.3 148.907L112.044 94.6263C112.414 92.0323 111.158 89.6263 109.104 88.3553Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M106.147 154.451C105.444 155.594 105.801 157.09 106.943 157.792L153.644 186.523C156.617 188.352 160.51 187.425 162.339 184.452C164.354 181.176 163.001 176.875 159.474 175.343L109.183 153.497C108.075 153.014 106.781 153.421 106.147 154.451Z",
    fill: "url(#paint11_linear_763_11589)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M106.147 154.451C105.444 155.594 105.801 157.09 106.943 157.792L153.644 186.523C156.617 188.352 160.51 187.425 162.339 184.452C164.354 181.176 163.001 176.875 159.474 175.343L109.183 153.497C108.075 153.014 106.781 153.421 106.147 154.451Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M159.475 175.342L109.184 153.496C108.336 153.128 107.382 153.282 106.695 153.835C106.81 154.498 107.188 155.112 107.806 155.492L154.507 184.223C157.472 186.047 161.349 185.128 163.185 182.174C163.643 179.412 162.223 176.536 159.475 175.342Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M102.602 154.451C103.305 155.594 102.948 157.09 101.806 157.792L55.1049 186.523C52.1319 188.352 48.2389 187.425 46.4099 184.452C44.3949 181.176 45.7479 176.875 49.2749 175.343L99.5659 153.497C100.674 153.014 101.969 153.421 102.602 154.451Z",
    fill: "url(#paint12_linear_763_11589)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.602 154.451C103.305 155.594 102.948 157.09 101.806 157.792L55.1049 186.523C52.1319 188.352 48.2389 187.425 46.4099 184.452C44.3949 181.176 45.7479 176.875 49.2749 175.343L99.5659 153.497C100.674 153.014 101.969 153.421 102.602 154.451Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M99.5659 153.497L49.2749 175.343C46.1859 176.685 44.7649 180.15 45.8119 183.19C47.8249 185.314 51.1139 185.817 53.7059 184.222L100.407 155.491C101.119 155.053 101.525 154.307 101.561 153.53C100.948 153.245 100.225 153.21 99.5659 153.497Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.238 217.982L105.206 219.159C106.847 219.302 108.449 219.363 109.73 219.363C110.969 219.363 112.505 219.305 114.088 219.171L114.056 217.995C112.763 218.104 111.326 218.172 109.73 218.172C108.067 218.172 106.574 218.099 105.238 217.982Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.363 229.355L114.17 222.192C112.893 222.312 111.418 222.392 109.731 222.392C107.964 222.392 106.445 222.302 105.126 222.171L104.932 229.349C106.532 229.479 108.162 229.535 109.731 229.535C111.247 229.535 112.817 229.477 114.363 229.355Z",
    fill: "#001F23"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M197.99 103.066H339.702L359.564 300.822L351.986 309.127H210.274L195.198 107.529L197.99 103.066Z",
    fill: "url(#paint13_linear_763_11589)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M217.852 300.822H359.564L339.702 103.066H197.99L217.852 300.822Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.555 306.294C257.847 306.294 296.139 306.294 334.431 306.294C339.889 306.294 345.347 306.294 350.805 306.294C351.77 306.294 351.772 304.794 350.805 304.794C312.513 304.794 274.221 304.794 235.929 304.794C230.471 304.794 225.013 304.794 219.555 304.794C218.59 304.794 218.589 306.294 219.555 306.294Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.251 204.804C206.797 233.712 209.342 262.62 211.888 291.529C212.248 295.617 212.608 299.706 212.968 303.794C213.052 304.748 214.553 304.757 214.468 303.794C211.922 274.886 209.377 245.978 206.831 217.069C206.471 212.981 206.111 208.892 205.751 204.804C205.667 203.85 204.166 203.841 204.251 204.804Z",
    fill: "white"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M293.3 134.651H306.431C308.014 134.651 309.185 133.368 309.046 131.785L308.905 130.177C308.767 128.594 307.371 127.311 305.788 127.311H292.657C291.074 127.311 289.903 128.594 290.042 130.177L290.183 131.785C290.322 133.368 291.717 134.651 293.3 134.651Z",
    fill: "url(#paint14_linear_763_11589)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M292.065 149.804H307.757C309.34 149.804 310.511 148.521 310.372 146.938L310.231 145.33C310.093 143.747 308.697 142.464 307.114 142.464H291.422C289.839 142.464 288.668 143.747 288.807 145.33L288.948 146.938C289.087 148.521 290.482 149.804 292.065 149.804Z",
    fill: "url(#paint15_linear_763_11589)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M295.952 164.956H309.083C310.666 164.956 311.837 163.673 311.698 162.09L311.557 160.482C311.419 158.899 310.023 157.616 308.44 157.616H295.31C293.727 157.616 292.556 158.899 292.695 160.482L292.836 162.09C292.974 163.673 294.369 164.956 295.952 164.956Z",
    fill: "url(#paint16_linear_763_11589)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M293.489 180.11H310.408C311.991 180.11 313.162 178.827 313.023 177.244L312.882 175.636C312.744 174.053 311.348 172.77 309.765 172.77H292.846C291.263 172.77 290.092 174.053 290.231 175.636L290.372 177.244C290.511 178.827 291.906 180.11 293.489 180.11Z",
    fill: "url(#paint17_linear_763_11589)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M297.536 195.263H336.784C338.367 195.263 339.538 193.98 339.399 192.397L339.258 190.789C339.12 189.206 337.724 187.923 336.141 187.923H296.893C295.31 187.923 294.139 189.206 294.278 190.789L294.419 192.397C294.558 193.98 295.953 195.263 297.536 195.263Z",
    fill: "url(#paint18_linear_763_11589)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M293.526 210.415H338.109C339.692 210.415 340.863 209.132 340.724 207.549L340.583 205.941C340.445 204.358 339.049 203.075 337.466 203.075H292.883C291.3 203.075 290.129 204.358 290.268 205.941L290.409 207.549C290.548 209.132 291.943 210.415 293.526 210.415Z",
    fill: "url(#paint19_linear_763_11589)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M298.694 225.569H339.436C341.019 225.569 342.19 224.286 342.051 222.703L341.91 221.095C341.771 219.512 340.376 218.229 338.793 218.229H298.051C296.468 218.229 295.297 219.512 295.436 221.095L295.577 222.703C295.715 224.286 297.111 225.569 298.694 225.569Z",
    fill: "url(#paint20_linear_763_11589)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.3 134.651H306.431C308.014 134.651 309.185 133.368 309.046 131.785L308.905 130.177C308.767 128.594 307.371 127.311 305.788 127.311H292.657C291.074 127.311 289.903 128.594 290.042 130.177L290.183 131.785C290.322 133.368 291.717 134.651 293.3 134.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.065 149.804H307.757C309.34 149.804 310.511 148.521 310.372 146.938L310.231 145.33C310.093 143.747 308.697 142.464 307.114 142.464H291.422C289.839 142.464 288.668 143.747 288.807 145.33L288.948 146.938C289.087 148.521 290.482 149.804 292.065 149.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.952 164.956H309.083C310.666 164.956 311.837 163.673 311.698 162.09L311.557 160.482C311.419 158.899 310.023 157.616 308.44 157.616H295.31C293.727 157.616 292.556 158.899 292.695 160.482L292.836 162.09C292.974 163.673 294.369 164.956 295.952 164.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.489 180.11H310.408C311.991 180.11 313.162 178.827 313.023 177.244L312.882 175.636C312.744 174.053 311.348 172.77 309.765 172.77H292.846C291.263 172.77 290.092 174.053 290.231 175.636L290.372 177.244C290.511 178.827 291.906 180.11 293.489 180.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.536 195.263H336.784C338.367 195.263 339.538 193.98 339.399 192.397L339.258 190.789C339.12 189.206 337.724 187.923 336.141 187.923H296.893C295.31 187.923 294.139 189.206 294.278 190.789L294.419 192.397C294.558 193.98 295.953 195.263 297.536 195.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.526 210.415H338.109C339.692 210.415 340.863 209.132 340.724 207.549L340.583 205.941C340.445 204.358 339.049 203.075 337.466 203.075H292.883C291.3 203.075 290.129 204.358 290.268 205.941L290.409 207.549C290.548 209.132 291.943 210.415 293.526 210.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.694 225.569H339.436C341.019 225.569 342.19 224.286 342.051 222.703L341.91 221.095C341.771 219.512 340.376 218.229 338.793 218.229H298.051C296.468 218.229 295.297 219.512 295.436 221.095L295.577 222.703C295.715 224.286 297.111 225.569 298.694 225.569Z",
    fill: "white"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M267.263 134.651H276.59C278.173 134.651 279.344 133.368 279.205 131.785L279.064 130.177C278.925 128.594 277.53 127.311 275.947 127.311H266.62C265.037 127.311 263.866 128.594 264.005 130.177L264.146 131.785C264.285 133.368 265.68 134.651 267.263 134.651Z",
    fill: "#26575D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M268.59 149.804H277.917C279.5 149.804 280.671 148.521 280.532 146.938L280.391 145.33C280.253 143.747 278.857 142.464 277.274 142.464H267.947C266.364 142.464 265.193 143.747 265.332 145.33L265.473 146.938C265.612 148.521 267.007 149.804 268.59 149.804Z",
    fill: "#26575D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M269.914 164.956H279.241C280.824 164.956 281.995 163.673 281.856 162.09L281.715 160.482C281.577 158.899 280.181 157.616 278.598 157.616H269.271C267.688 157.616 266.517 158.899 266.656 160.482L266.797 162.09C266.936 163.673 268.332 164.956 269.914 164.956Z",
    fill: "#26575D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M271.24 180.11H280.567C282.15 180.11 283.321 178.827 283.182 177.244L283.041 175.636C282.903 174.053 281.507 172.77 279.924 172.77H270.597C269.014 172.77 267.843 174.053 267.982 175.636L268.123 177.244C268.262 178.827 269.657 180.11 271.24 180.11Z",
    fill: "#26575D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M272.567 195.263H281.894C283.477 195.263 284.648 193.98 284.509 192.397L284.368 190.789C284.23 189.206 282.834 187.923 281.251 187.923H271.924C270.341 187.923 269.17 189.206 269.309 190.789L269.45 192.397C269.589 193.98 270.984 195.263 272.567 195.263Z",
    fill: "#26575D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M273.891 210.415H283.218C284.801 210.415 285.972 209.132 285.833 207.549L285.692 205.941C285.553 204.358 284.158 203.075 282.575 203.075H273.248C271.665 203.075 270.494 204.358 270.633 205.941L270.774 207.549C270.913 209.132 272.309 210.415 273.891 210.415Z",
    fill: "#26575D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M275.217 225.569H284.544C286.127 225.569 287.298 224.286 287.159 222.703L287.018 221.095C286.88 219.512 285.484 218.229 283.901 218.229H274.574C272.991 218.229 271.82 219.512 271.959 221.095L272.1 222.703C272.239 224.286 273.634 225.569 275.217 225.569Z",
    fill: "#26575D"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.263 134.651H276.59C278.173 134.651 279.344 133.368 279.205 131.785L279.064 130.177C278.925 128.594 277.53 127.311 275.947 127.311H266.62C265.037 127.311 263.866 128.594 264.005 130.177L264.146 131.785C264.285 133.368 265.68 134.651 267.263 134.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.59 149.804H277.917C279.5 149.804 280.671 148.521 280.532 146.938L280.391 145.33C280.253 143.747 278.857 142.464 277.274 142.464H267.947C266.364 142.464 265.193 143.747 265.332 145.33L265.473 146.938C265.612 148.521 267.007 149.804 268.59 149.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.914 164.956H279.241C280.824 164.956 281.995 163.673 281.856 162.09L281.715 160.482C281.577 158.899 280.181 157.616 278.598 157.616H269.271C267.688 157.616 266.517 158.899 266.656 160.482L266.797 162.09C266.936 163.673 268.332 164.956 269.914 164.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.24 180.11H280.567C282.15 180.11 283.321 178.827 283.182 177.244L283.041 175.636C282.903 174.053 281.507 172.77 279.924 172.77H270.597C269.014 172.77 267.843 174.053 267.982 175.636L268.123 177.244C268.262 178.827 269.657 180.11 271.24 180.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.567 195.263H281.894C283.477 195.263 284.648 193.98 284.509 192.397L284.368 190.789C284.23 189.206 282.834 187.923 281.251 187.923H271.924C270.341 187.923 269.17 189.206 269.309 190.789L269.45 192.397C269.589 193.98 270.984 195.263 272.567 195.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.891 210.415H283.218C284.801 210.415 285.972 209.132 285.833 207.549L285.692 205.941C285.553 204.358 284.158 203.075 282.575 203.075H273.248C271.665 203.075 270.494 204.358 270.633 205.941L270.774 207.549C270.913 209.132 272.309 210.415 273.891 210.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.217 225.569H284.544C286.127 225.569 287.298 224.286 287.159 222.703L287.018 221.095C286.88 219.512 285.484 218.229 283.901 218.229H274.574C272.991 218.229 271.82 219.512 271.959 221.095L272.1 222.703C272.239 224.286 273.634 225.569 275.217 225.569Z",
    fill: "white"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M227.422 244.906H271.459C273.042 244.906 274.213 243.623 274.074 242.04L273.933 240.432C273.795 238.849 272.399 237.566 270.816 237.566H226.78C225.197 237.566 224.026 238.849 224.165 240.432L224.306 242.04C224.444 243.623 225.839 244.906 227.422 244.906Z",
    fill: "#26575D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M226.186 260.06H272.784C274.367 260.06 275.538 258.777 275.399 257.194L275.258 255.586C275.12 254.003 273.724 252.72 272.141 252.72H225.543C223.96 252.72 222.789 254.003 222.928 255.586L223.069 257.194C223.208 258.776 224.604 260.06 226.186 260.06Z",
    fill: "#26575D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M230.073 275.211H274.11C275.693 275.211 276.864 273.928 276.725 272.345L276.584 270.737C276.446 269.154 275.05 267.871 273.467 267.871H229.43C227.847 267.871 226.676 269.154 226.815 270.737L226.956 272.345C227.095 273.928 228.49 275.211 230.073 275.211Z",
    fill: "#26575D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M227.611 290.364H275.436C277.019 290.364 278.19 289.081 278.051 287.498L277.91 285.89C277.771 284.307 276.376 283.024 274.793 283.024H226.968C225.385 283.024 224.214 284.307 224.353 285.89L224.494 287.498C224.633 289.081 226.028 290.364 227.611 290.364Z",
    fill: "#26575D"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.422 244.906H271.459C273.042 244.906 274.213 243.623 274.074 242.04L273.933 240.432C273.795 238.849 272.399 237.566 270.816 237.566H226.78C225.197 237.566 224.026 238.849 224.165 240.432L224.306 242.04C224.444 243.623 225.839 244.906 227.422 244.906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.186 260.06H272.784C274.367 260.06 275.538 258.777 275.399 257.194L275.258 255.586C275.12 254.003 273.724 252.72 272.141 252.72H225.543C223.96 252.72 222.789 254.003 222.928 255.586L223.069 257.194C223.208 258.776 224.604 260.06 226.186 260.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.073 275.211H274.11C275.693 275.211 276.864 273.928 276.725 272.345L276.584 270.737C276.446 269.154 275.05 267.871 273.467 267.871H229.43C227.847 267.871 226.676 269.154 226.815 270.737L226.956 272.345C227.095 273.928 228.49 275.211 230.073 275.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.611 290.364H275.436C277.019 290.364 278.19 289.081 278.051 287.498L277.91 285.89C277.771 284.307 276.376 283.024 274.793 283.024H226.968C225.385 283.024 224.214 284.307 224.353 285.89L224.494 287.498C224.633 289.081 226.028 290.364 227.611 290.364Z",
    fill: "white"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M260.274 106.765L261.688 106.469L254.577 82.1668C253.905 79.8708 254.224 77.5858 255.453 75.8978C256.668 74.2298 258.591 73.3118 260.871 73.3118C265.695 73.3118 270.317 77.5208 270.761 82.3188L273.011 106.621L274.48 106.612L272.23 82.3098C271.714 76.7338 266.346 71.8418 260.743 71.8418C258.053 71.8418 255.68 72.9818 254.232 74.9688C252.753 76.9998 252.363 79.7308 253.163 82.4618L260.274 106.765Z",
    fill: "#001F23"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M249.814 110.744H290.453L288.833 92.2293C288.644 90.0713 286.742 88.3223 284.584 88.3223H251.758C249.6 88.3223 248.004 90.0713 248.193 92.2293L249.814 110.744Z",
    fill: "url(#paint21_linear_763_11589)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.814 110.744H290.453L288.833 92.2293C288.644 90.0713 286.742 88.3223 284.584 88.3223H251.758C249.6 88.3223 248.004 90.0713 248.193 92.2293L249.814 110.744Z",
    fill: "#001F23"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M264.385 106.69L265.835 106.544L261.279 82.2418C260.851 79.9628 261.403 77.6818 262.79 75.9848C264.179 74.2868 266.288 73.3128 268.579 73.3128C270.87 73.3128 273.149 74.2878 274.835 75.9848C276.52 77.6828 277.47 79.9628 277.441 82.2418L277.137 106.544L278.612 106.69L278.916 82.3878C278.95 79.6968 277.828 77.0028 275.838 74.9978C273.848 72.9918 271.155 71.8418 268.451 71.8418C265.746 71.8418 263.254 72.9918 261.615 74.9978C259.976 77.0028 259.325 79.6968 259.83 82.3878L264.385 106.69Z",
    fill: "#001F23"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.385 106.69L265.835 106.544L261.279 82.2418C260.851 79.9628 261.403 77.6818 262.79 75.9848C264.179 74.2868 266.288 73.3128 268.579 73.3128C270.87 73.3128 273.149 74.2878 274.835 75.9848C276.52 77.6828 277.47 79.9628 277.441 82.2418L277.137 106.544L278.612 106.69L278.916 82.3878C278.95 79.6968 277.828 77.0028 275.838 74.9978C273.848 72.9918 271.155 71.8418 268.451 71.8418C265.746 71.8418 263.254 72.9918 261.615 74.9978C259.976 77.0028 259.325 79.6968 259.83 82.3878L264.385 106.69Z",
    fill: "white"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M248.515 113.547H292.243C293.002 113.547 293.564 112.931 293.498 112.172L293.289 109.784C293.223 109.025 292.553 108.409 291.794 108.409H248.066C247.307 108.409 246.745 109.025 246.811 109.784L247.02 112.172C247.086 112.931 247.756 113.547 248.515 113.547Z",
    fill: "url(#paint22_linear_763_11589)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.922 244.89H337.888H327.475H326.441H316.028H314.994H304.581H303.547H293.134H292.1H280.653L281.657 256.37L281.744 257.37L282.661 267.85L282.748 268.85L283.665 279.33L283.752 280.33L284.756 291.809H296.203H297.237H307.65H308.684H319.1H320.134H330.547H331.581H341.994H343.028H354.475L353.471 280.33L353.383 279.33L352.466 268.85L352.379 267.85L351.462 257.37L351.375 256.37L350.371 244.89H338.922ZM339.897 267.851H329.484L328.567 257.371H338.98L339.897 267.851ZM328.45 267.851H318.037L317.12 257.371H327.533L328.45 267.851ZM317.004 267.851H306.591L305.674 257.371H316.087L317.004 267.851ZM305.557 267.851H295.144L294.227 257.371H304.64L305.557 267.851ZM295.231 268.851H305.644L306.561 279.331H296.148L295.231 268.851ZM306.678 268.851H317.091L318.008 279.331H307.595L306.678 268.851ZM318.125 268.851H328.538L329.455 279.331H319.042L318.125 268.851ZM329.572 268.851H339.985L340.902 279.331H330.489L329.572 268.851ZM337.976 245.89L338.893 256.37H328.48L327.563 245.89H337.976ZM326.529 245.89L327.446 256.37H317.033L316.116 245.89H326.529ZM315.082 245.89L315.999 256.37H305.586L304.669 245.89H315.082ZM303.635 245.89L304.552 256.37H294.139L293.222 245.89H303.635ZM281.742 245.89H292.189L293.106 256.37H282.659L281.742 245.89ZM282.746 257.371H293.193L294.11 267.851H283.663L282.746 257.371ZM283.751 268.851H294.198L295.115 279.331H284.668L283.751 268.851ZM285.672 290.811L284.755 280.332H295.202L296.119 290.811H285.672ZM297.152 290.811L296.235 280.332H306.648L307.565 290.811H297.152ZM308.599 290.811L307.682 280.332H318.095L319.012 290.811H308.599ZM320.046 290.811L319.129 280.332H329.542L330.459 290.811H320.046ZM331.493 290.811L330.576 280.332H340.989L341.906 290.811H331.493ZM353.386 290.811H342.94L342.023 280.332H352.47L353.386 290.811ZM352.382 279.332H341.935L341.018 268.852H351.465L352.382 279.332ZM351.378 267.851H340.931L340.014 257.371H350.461L351.378 267.851ZM339.926 256.371L339.009 245.891H349.456L350.373 256.371H339.926Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M299.611 290.972H292.211L291.206 279.661H298.606L299.611 290.972Z",
    fill: "url(#paint23_linear_763_11589)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M314.41 290.973H307.01L305 268.35H312.4L314.41 290.973Z",
    fill: "#26575D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M329.209 290.972H321.81L320.494 276.163H327.894L329.209 290.972Z",
    fill: "url(#paint24_linear_763_11589)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M344.009 290.972H336.609L333.831 259.706H341.231L344.009 290.972Z",
    fill: "#26575D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M290.002 266.108C289.417 265.173 289.666 264.009 290.556 263.507L307.259 254.099L322.422 259.036L337.626 248.921C338.474 248.357 339.684 248.628 340.328 249.526C340.972 250.424 340.806 251.61 339.958 252.174L323.299 263.255L307.982 258.268L292.673 266.892C291.782 267.395 290.586 267.043 290.002 266.108Z",
    fill: "url(#paint25_linear_763_11589)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M332.35 252.719C332.35 252.719 340.917 244.651 330.476 241.236C330.476 241.236 325.747 250.383 330.963 252.719C330.963 252.719 333.47 248.534 332.015 244.159C332.015 244.159 334.868 247.425 332.35 252.719Z",
    fill: "url(#paint26_linear_763_11589)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M338.792 252.92C338.792 252.92 346.035 243.636 350.351 253.774C350.351 253.774 341.696 259.315 338.915 254.308C338.915 254.308 342.844 251.431 347.314 252.496C347.314 252.496 343.82 249.932 338.792 252.92Z",
    fill: "url(#paint27_linear_763_11589)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M241.213 166.948C251.408 166.948 258.95 158.683 258.058 148.488C257.166 138.293 248.178 130.028 237.983 130.028C237.147 130.028 236.336 130.103 235.539 130.211C234.723 130.103 233.899 130.028 233.063 130.028C222.867 130.028 215.326 138.293 216.218 148.488H227.642C227.138 142.728 230.791 137.922 236.115 136.787C241.637 137.922 246.132 142.728 246.636 148.488C247.214 155.092 242.329 160.445 235.725 160.445L236.294 166.948H241.213Z",
    fill: "url(#paint28_linear_763_11589)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M239.273 169.074L238.704 162.571C232.1 162.571 226.279 157.218 225.701 150.614H214.278C215.17 160.809 224.158 169.074 234.353 169.074H239.273Z",
    fill: "url(#paint29_linear_763_11589)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M241.213 166.948C251.408 166.948 258.95 158.683 258.058 148.488C257.166 138.293 248.178 130.028 237.983 130.028C237.147 130.028 236.336 130.103 235.539 130.211C234.723 130.103 233.899 130.028 233.063 130.028C222.867 130.028 215.326 138.293 216.218 148.488H227.642C227.138 142.728 230.791 137.922 236.115 136.787C241.637 137.922 246.132 142.728 246.636 148.488C247.214 155.092 242.329 160.445 235.725 160.445L236.294 166.948H241.213Z",
    fill: "#26575D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M239.273 169.074L238.704 162.571C232.1 162.571 226.279 157.218 225.701 150.614H214.278C215.17 160.809 224.158 169.074 234.353 169.074H239.273Z",
    fill: "#26575D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M227.641 148.488C227.063 141.885 231.948 136.531 238.552 136.531C245.156 136.531 250.978 141.885 251.555 148.488C252.133 155.092 247.248 160.445 240.644 160.445L241.213 166.948C251.408 166.948 258.95 158.683 258.058 148.488C257.166 138.293 248.178 130.028 237.983 130.028C227.788 130.028 220.246 138.293 221.138 148.488H227.641Z",
    fill: "url(#paint30_linear_763_11589)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M219.198 150.614C220.09 160.809 229.078 169.074 239.273 169.074L238.704 162.571C232.1 162.571 226.279 157.218 225.701 150.614H219.198Z",
    fill: "url(#paint31_linear_763_11589)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M219.198 150.614C220.09 160.809 229.078 169.074 239.273 169.074L238.704 162.571C232.1 162.571 226.279 157.218 225.701 150.614H219.198Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M238.045 184.308C237.849 182.067 237.779 181.265 237.582 179.019H232.662C227.564 179.019 223.13 181.085 220.082 184.426L225.083 189.025H230.003C231.494 187.39 233.499 186.229 235.813 185.758C235.941 187.22 236.026 188.191 236.241 190.645C242.845 190.645 248.667 195.999 249.244 202.602H260.667C259.775 192.407 250.787 184.142 240.591 184.142L238.045 184.308Z",
    fill: "url(#paint32_linear_763_11589)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M246.133 223.187C256.328 223.187 263.87 214.922 262.978 204.727H251.555C252.048 210.367 248.551 215.082 243.408 216.343L243.252 214.559C236.648 214.559 230.827 209.206 230.249 202.602C229.96 199.3 231.037 196.311 233.012 194.147L228.011 189.548H223.091C220.043 192.889 218.38 197.504 218.826 202.601C219.718 212.796 228.706 221.061 238.901 221.061L241.007 220.827L241.213 223.187H246.133Z",
    fill: "url(#paint33_linear_763_11589)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M238.045 184.308C237.849 182.067 237.779 181.265 237.582 179.019H232.662C227.564 179.019 223.13 181.085 220.082 184.426L225.083 189.025H230.003C231.494 187.39 233.499 186.229 235.813 185.758C235.941 187.22 236.026 188.191 236.241 190.645C242.845 190.645 248.667 195.999 249.244 202.602H260.667C259.775 192.407 250.787 184.142 240.591 184.142L238.045 184.308Z",
    fill: "#26575D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M246.133 223.187C256.328 223.187 263.87 214.922 262.978 204.727H251.555C252.048 210.367 248.551 215.082 243.408 216.343L243.252 214.559C236.648 214.559 230.827 209.206 230.249 202.602C229.96 199.3 231.037 196.311 233.012 194.147L228.011 189.548H223.091C220.043 192.889 218.38 197.504 218.826 202.601C219.718 212.796 228.706 221.061 238.901 221.061L241.007 220.827L241.213 223.187H246.133Z",
    fill: "#26575D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M256.475 204.726C257.053 211.33 252.168 216.683 245.564 216.683L246.133 223.186C256.328 223.186 263.87 214.921 262.978 204.726H256.475Z",
    fill: "url(#paint34_linear_763_11589)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M256.475 204.726C257.053 211.33 252.168 216.683 245.564 216.683L246.133 223.186C256.328 223.186 263.87 214.921 262.978 204.726H256.475Z",
    fill: "#001F23"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M240.591 184.14C250.786 184.14 259.774 192.405 260.666 202.6H254.163C253.585 195.997 247.764 190.643 241.16 190.643C240.877 187.405 240.82 186.751 240.591 184.14Z",
    fill: "url(#paint35_linear_763_11589)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M233.012 194.146C231.037 196.31 229.961 199.299 230.249 202.601C230.827 209.205 236.649 214.558 243.252 214.558L243.821 221.061C233.626 221.061 224.638 212.796 223.746 202.601C223.3 197.503 224.963 192.888 228.011 189.548L233.012 194.146Z",
    fill: "url(#paint36_linear_763_11589)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M230.003 189.024L225.002 184.425C228.05 181.084 232.485 179.018 237.582 179.018C237.81 181.629 237.868 182.283 238.151 185.521C234.849 185.521 231.977 186.86 230.003 189.024Z",
    fill: "url(#paint37_linear_763_11589)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.003 189.024L225.002 184.425C228.05 181.084 232.485 179.018 237.582 179.018C237.81 181.629 237.868 182.283 238.151 185.521C234.849 185.521 231.977 186.86 230.003 189.024Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M372.282 342.344L367.886 353.3L361.552 351.696L364.721 339.501L372.282 342.344Z",
    fill: "#F7A47A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M414.334 340.345L412.484 352.005L405.952 351.85L406.33 339.256L414.334 340.345Z",
    fill: "#F7A47A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M354.091 357.899C359.898 357.983 360.667 357.904 363.931 357.842C366.727 357.782 367.39 358.141 369.636 358.124C371.512 358.111 371.469 356.314 370.92 354.24C370.645 353.199 370.231 350.999 369.856 349.317L362.315 346.556C361.085 348.824 357.379 354.065 354.1 354.457C350.97 354.83 351.776 357.866 354.091 357.899Z",
    fill: "url(#paint38_linear_763_11589)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M380.906 195.606C380.906 195.606 376.763 256.573 374.181 279.826C370.901 309.367 365.758 331.652 361.453 346.966C362.613 348.029 367.547 348.545 370.344 348.298C370.344 348.298 390.509 313.782 388.608 283.542C408.097 230.284 402.225 197.766 402.225 197.766L380.906 195.606Z",
    fill: "#26575D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M392.61 265.742C395.033 248.49 391.788 218.801 391.788 218.801L393.421 209.098L396.983 212.024L403.16 218.072C402.345 229.07 399.639 244.784 392.61 265.742Z",
    fill: "#001F23"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M398.192 357.376C403.998 357.254 404.764 357.149 408.024 356.971C410.816 356.812 411.491 357.148 413.735 357.051C415.61 356.972 415.502 355.177 414.88 353.124C414.569 352.093 414.077 349.909 413.643 348.242L405.124 347.802C403.975 350.112 401.342 353.427 398.079 353.936C394.964 354.42 395.877 357.425 398.192 357.376Z",
    fill: "url(#paint39_linear_763_11589)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M388.696 198.555C388.696 198.555 397.777 255.353 401.819 278.398C406.065 302.6 405.49 332.661 404.889 348.557C406.266 349.318 411.183 348.665 413.844 347.771C413.844 347.771 423.737 304.51 418.394 280.449C424.874 224.109 411.637 201.695 411.637 201.695L388.696 198.555Z",
    fill: "#26575D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M385.618 156.268C383.953 161.801 377.956 172.77 367.843 175.287C367.843 175.287 369.148 180.527 364.725 180.038C364.725 180.038 375.005 183.484 382.014 177.108C392.678 167.408 395.034 154.179 390.296 152.243C387.217 150.984 386.105 154.65 385.618 156.268Z",
    fill: "url(#paint40_linear_763_11589)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.618 156.268C383.953 161.801 377.837 172.77 367.843 175.287C367.843 175.287 369.148 180.527 364.725 180.038C364.725 180.038 375.005 183.484 382.014 177.108C392.678 167.408 395.034 154.179 390.296 152.243C387.217 150.984 386.105 154.65 385.618 156.268Z",
    fill: "#001F23"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M380.534 163.044C379.8 166.046 380.823 171.576 380.891 179.018C380.827 185.301 381.56 189.547 380.025 201.18L412.953 202.423C412.752 193.474 413.574 183.531 420.305 164.363C421.866 159.919 419.12 155.079 414.406 153.967C413.146 153.67 411.809 153.384 410.434 153.132C405.089 152.155 400.705 151.394 395.924 151.177C394.34 151.105 392.689 151.233 391.122 151.084C388.696 150.854 381.985 157.109 380.534 163.044Z",
    fill: "#26575D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M396.835 119.718C396.835 119.718 391.114 119.852 394.388 129.717L398.088 123.255L396.835 119.718Z",
    fill: "#26575D"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M409.621 138.257C408.151 142.619 406.209 150.712 409.049 154.138C409.049 154.138 404.723 152.907 395.191 157.293C392.7 153.149 394.751 152.211 394.751 152.211C400.032 151.708 400.37 147.981 399.918 144.377L409.621 138.257Z",
    fill: "#F7A47A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.665 140.755L399.922 144.374C400.032 145.227 400.093 146.086 400.049 146.907C402.044 146.895 405.002 145.161 405.463 143.19C405.695 142.206 405.773 141.242 405.665 140.755Z",
    fill: "#001F23"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M414.392 127.706C413.384 135.163 413.116 138.333 409.084 142.092C403.019 147.747 394.164 145.377 392.943 137.89C391.845 131.151 393.677 120.088 401.162 117.257C408.536 114.468 415.399 120.248 414.392 127.706Z",
    fill: "#F7A47A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M402.754 130.849C402.7 131.443 402.348 131.919 401.969 131.91C401.59 131.902 401.326 131.413 401.38 130.818C401.434 130.223 401.786 129.748 402.165 129.757C402.545 129.766 402.809 130.254 402.754 130.849Z",
    fill: "#26575D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M395.373 130.459C395.319 131.053 394.967 131.529 394.588 131.52C394.209 131.512 393.945 131.023 394 130.428C394.054 129.834 394.406 129.358 394.785 129.367C395.164 129.375 395.427 129.864 395.373 130.459Z",
    fill: "#26575D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M394.949 129.404L393.593 128.962C393.593 128.962 394.206 130.092 394.949 129.404Z",
    fill: "#26575D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M397.509 131.815C397.509 131.815 396.291 134.353 395.094 135.564C395.793 136.313 397.126 136.008 397.126 136.008L397.509 131.815Z",
    fill: "#4D7479"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M404.185 127.147C404.094 127.153 404.004 127.123 403.937 127.056C402.891 126.001 401.649 126.302 401.635 126.306C401.451 126.351 401.272 126.24 401.238 126.053C401.205 125.866 401.329 125.676 401.515 125.629C401.58 125.613 403.138 125.233 404.436 126.543C404.565 126.674 404.558 126.895 404.421 127.037C404.354 127.104 404.27 127.141 404.185 127.147Z",
    fill: "#26575D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M392.702 126.478C392.617 126.495 392.529 126.48 392.456 126.43C392.305 126.326 392.273 126.11 392.386 125.948C393.516 124.32 395.094 124.286 395.162 124.286C395.351 124.284 395.494 124.439 395.482 124.632C395.47 124.825 395.308 124.982 395.12 124.985C395.058 124.985 393.834 125.03 392.935 126.325C392.877 126.407 392.792 126.46 392.702 126.478Z",
    fill: "#26575D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M402.33 129.795L400.974 129.353C400.974 129.353 401.587 130.484 402.33 129.795Z",
    fill: "#26575D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M396.237 138.158C396.237 138.158 397.969 137.768 402.761 137.8C402.107 139.27 400.984 140.467 398.531 140.426C396.078 140.387 396.237 138.158 396.237 138.158Z",
    fill: "#26575D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M399.742 139.274C398.558 139.254 397.685 139.525 397.024 139.969C397.356 140.23 397.844 140.412 398.529 140.423C399.713 140.442 400.58 140.179 401.242 139.728C400.909 139.467 400.427 139.286 399.742 139.274Z",
    fill: "url(#paint41_linear_763_11589)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M396.457 138.118C396.573 138.433 396.688 138.749 397.162 138.854C398.156 138.93 400.73 138.657 401.426 138.515C401.87 138.444 402.255 138.293 402.554 137.799C398.863 137.783 397.045 138.02 396.457 138.118Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M412.529 133.011C412.529 133.011 407.519 131.309 405.301 121.603C405.301 121.603 403.974 124.528 406.587 129.901C406.587 129.901 400.515 127.83 400.949 121.694C400.949 121.694 396.168 124.689 399.603 129.108C399.603 129.108 391.776 124.637 396.816 118.78C396.816 118.78 396.578 107.408 407.636 114.302C407.636 114.302 434.696 122.862 411.76 138.832L412.529 133.011Z",
    fill: "#26575D"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M416.395 133.905C415.445 135.402 413.966 136.305 412.635 136.579C410.632 136.991 409.875 134.998 410.637 133.041C411.323 131.28 413.191 128.944 415.103 129.416C416.986 129.881 417.481 132.193 416.395 133.905Z",
    fill: "#F7A47A"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M400.823 115.696C400.823 115.696 390.836 116.646 392.836 123.74C392.836 123.74 393.964 119.715 399.989 120.089L400.823 115.696Z",
    fill: "#26575D"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M400.823 115.696C400.823 115.696 396.905 116.586 395.888 112.202C395.888 112.202 392.358 119.124 399.015 117.609L400.823 115.696Z",
    fill: "#26575D"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M409.958 154.325C409.958 154.325 407.881 152.923 407.838 148.982C407.831 148.341 407.27 147.856 406.641 147.975C405.26 148.235 402.875 148.446 400.183 147.643C399.609 147.472 399.017 147.827 398.901 148.415C398.637 149.749 397.82 151.745 395.287 151.756L391.318 153.027L393.156 158.49L398.259 159.071L408.355 157.859L410.774 154.995L409.958 154.325Z",
    fill: "#26575D"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M409.213 151.9C408.543 151.736 407.844 151.899 407.309 152.334C404.979 154.227 398.867 160.578 396.742 176.341C394.095 195.979 403.161 218.071 403.161 218.071L419.977 213.94C419.977 213.94 412.962 203.728 413.918 193.313C414.874 182.897 423.438 162.524 421.329 158.233C419.606 154.729 411.96 152.573 409.213 151.9Z",
    fill: "url(#paint42_linear_763_11589)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M409.213 151.9C408.543 151.736 407.844 151.899 407.309 152.334C404.979 154.227 398.867 160.578 396.742 176.341C394.095 195.979 403.161 218.071 403.161 218.071L419.977 213.94C419.977 213.94 412.962 203.728 413.918 193.313C414.874 182.897 423.438 162.524 421.329 158.233C419.606 154.729 411.96 152.573 409.213 151.9Z",
    fill: "#001F23"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M409.454 153.336C409.454 153.336 408.652 160.599 407.271 162.51C406.745 163.238 404.023 163.518 404.215 164.395C404.446 165.45 408.076 163.93 408.504 164.922C410.229 168.919 397.195 178.975 397.195 178.975C397.195 178.975 407.737 169.545 406.18 166.096C405.595 164.801 400.85 166.545 400.576 165.151C400.262 163.552 405.069 162.964 406.115 161.715C407.562 159.985 409.454 153.336 409.454 153.336Z",
    fill: "#001F23"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M396.457 150.835C396.799 150.904 396.824 150.966 396.53 151.155C394.287 152.602 389.21 158.494 387.332 182.378C384.891 213.426 380.594 216.392 380.594 216.392L376.297 214.982C376.297 214.982 377.993 209.39 378.951 196.466C379.322 191.459 378.779 182.372 378.825 173.841C378.894 160.787 385.53 148.631 396.457 150.835Z",
    fill: "url(#paint43_linear_763_11589)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M396.457 150.835C396.799 150.903 396.824 150.966 396.53 151.155C394.287 152.602 389.21 158.494 387.332 182.378C384.891 213.426 380.594 216.392 380.594 216.392L376.297 214.982C376.297 214.982 377.993 209.39 378.951 196.466C379.322 191.459 378.779 182.372 378.825 173.841C378.894 160.787 385.397 148.631 396.457 150.835Z",
    fill: "#001F23"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M392.95 152.535C392.95 152.535 386.161 158.136 386.205 160.803C386.22 161.713 388.906 162.69 388.596 163.545C388.18 164.692 384.466 163.305 383.778 164.313C382.069 166.815 386.377 177.157 386.377 177.157C386.377 177.157 380.091 166.143 381.88 163.227C382.401 162.378 385.498 163.624 385.826 162.684C386.045 162.058 383.974 161.428 383.995 160.766C384.095 157.728 392.95 152.535 392.95 152.535Z",
    fill: "#001F23"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M399.695 195.065L362.873 166.025C372.254 153.359 370.279 135.417 358.051 125.133C345.339 114.442 326.367 116.08 315.675 128.791C304.984 141.503 306.622 160.475 319.334 171.167C331.561 181.451 349.576 180.322 360.447 168.908L395.368 200.208C396.782 201.475 398.963 201.321 400.185 199.868C401.408 198.416 401.185 196.241 399.695 195.065ZM321.429 168.676C310.093 159.142 308.632 142.223 318.166 130.887C327.7 119.551 344.619 118.09 355.955 127.624C367.291 137.158 368.752 154.077 359.218 165.413C349.684 176.749 332.765 178.211 321.429 168.676Z",
    fill: "#26575D"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M399.695 195.065L362.873 166.025C372.254 153.359 370.279 135.417 358.051 125.133C345.339 114.442 326.367 116.08 315.675 128.791C304.984 141.503 306.622 160.475 319.334 171.167C331.561 181.451 349.576 180.322 360.447 168.908L395.368 200.208C396.782 201.475 398.963 201.321 400.185 199.868C401.408 198.416 401.185 196.241 399.695 195.065ZM321.429 168.676C310.093 159.142 308.632 142.223 318.166 130.887C327.7 119.551 344.619 118.09 355.955 127.624C367.291 137.158 368.752 154.077 359.218 165.413C349.684 176.749 332.765 178.211 321.429 168.676Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M395.616 189.712C397.159 190.693 398.681 191.479 400.285 192.263C401.889 193.017 403.549 193.688 405.308 194.249C407.078 194.782 408.923 195.261 411.076 195.362C412.158 195.402 413.329 195.366 414.666 195.029C415.977 194.706 417.571 193.943 418.786 192.532C418.936 192.358 419.064 192.172 419.169 191.978L419.294 191.743C420.274 189.91 421.092 187.988 421.667 186.013C422.267 184.044 422.663 182.035 422.892 180.022C423.127 178.01 423.183 175.994 423.091 173.989C423.038 172.986 422.95 171.986 422.824 170.981C422.761 170.479 422.691 169.974 422.6 169.466L422.449 168.694L422.25 167.818C421.701 165.398 419.294 163.882 416.874 164.43C414.533 164.961 413.037 167.231 413.44 169.57L413.506 169.949L413.583 170.391L413.668 170.945L413.828 172.097C413.924 172.875 413.992 173.666 414.031 174.457C414.123 176.04 414.111 177.625 414.016 179.191C413.816 182.111 413.231 184.944 412.209 187.584C411.916 187.69 411.498 187.779 411.025 187.823C409.815 187.932 408.323 187.856 406.821 187.647C405.307 187.455 403.746 187.151 402.177 186.806C400.61 186.483 398.999 186.05 397.475 185.66L397.378 185.635C396.175 185.327 394.95 186.053 394.642 187.255C394.397 188.223 394.819 189.204 395.616 189.712Z",
    fill: "#F7A47A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M389.82 182.733L391.855 182.226C392.62 182.036 393.464 182.233 394.119 182.757L397.182 185.204C398.406 186.182 399.781 188.942 399.111 190.065C397.334 193.042 391.24 189.812 391.24 189.812L389.906 189.574C388.718 189.362 387.873 188.328 387.965 187.2L388.177 184.602C388.249 183.704 388.904 182.961 389.82 182.733Z",
    fill: "#F7A47A"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M416.154 155.701C417.295 155.09 418.705 155.316 419.721 156.119C422.191 158.071 426.095 163.617 424.241 178.802C421.609 200.362 410.749 197.338 398.457 191.511L399.214 185.849C399.214 185.849 407.623 188.225 412.011 187.321C412.011 187.321 414.186 182.006 413.847 175.978C413.535 170.452 410.563 158.694 416.154 155.701Z",
    fill: "url(#paint44_linear_763_11589)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M416.154 155.701C417.295 155.09 418.705 155.316 419.721 156.119C422.191 158.071 426.095 163.617 424.241 178.802C421.609 200.362 410.749 197.338 398.457 191.511L399.214 185.849C399.214 185.849 407.623 188.225 412.011 187.321C412.011 187.321 414.186 182.006 413.847 175.978C413.535 170.452 410.563 158.694 416.154 155.701Z",
    fill: "#001F23"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M358.675 174.412L359.249 176.548C359.465 177.351 360.051 178.035 360.822 178.383L364.427 180.011C364.607 180.092 364.822 180.144 365.06 180.171C367.507 180.455 369.199 177.659 367.921 175.553C366.751 173.626 365.423 172.224 365.423 172.224L364.56 171.106C363.791 170.11 362.49 169.838 361.572 170.482L359.458 171.964C358.728 172.476 358.416 173.45 358.675 174.412Z",
    fill: "#F7A47A"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M338.848 135.048L334.031 143.323L326.621 138.877L332.796 128.132H345.147L338.848 135.048Z",
    fill: "url(#paint45_linear_763_11589)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M349.592 152.955L344.776 144.557L352.309 140.358L358.608 151.103C356.632 154.561 354.285 158.513 352.433 161.848L349.592 152.955Z",
    fill: "url(#paint46_linear_763_11589)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M328.72 153.326H338.229V161.971H325.756C323.78 158.637 321.433 154.561 319.581 151.226L328.72 153.326Z",
    fill: "url(#paint47_linear_763_11589)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M345.147 128.132L348.852 134.431L350.709 133.379C351.223 133.088 351.793 133.661 351.498 134.173L347.618 140.916C347.466 141.18 347.178 141.337 346.874 141.322L339.739 140.961C339.154 140.931 338.976 140.151 339.492 139.872C340.027 139.582 340.55 139.291 341.072 139.001C340.578 138.013 339.713 136.531 338.849 135.049L345.147 128.132Z",
    fill: "url(#paint48_linear_763_11589)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M352.432 161.849H345.146L345.081 164.118C345.064 164.703 344.29 164.898 343.998 164.391L340.084 157.587C339.932 157.323 339.941 156.995 340.107 156.74L343.967 150.814C344.285 150.325 345.044 150.559 345.033 151.142C345.022 151.716 345.022 152.286 345.022 152.833C346.133 152.956 347.863 152.956 349.591 152.956L352.432 161.849Z",
    fill: "url(#paint49_linear_763_11589)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M319.581 151.227L323.162 144.928L321.31 143.778C320.814 143.47 321.032 142.705 321.616 142.705H329.46C329.764 142.705 330.042 142.875 330.181 143.145L333.464 149.529C333.736 150.057 333.133 150.603 332.633 150.282C332.11 149.946 331.588 149.598 331.065 149.25C330.448 150.238 329.583 151.72 328.718 153.325L319.581 151.227Z",
    fill: "url(#paint50_linear_763_11589)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M345.147 128.132L348.852 134.431L350.709 133.379C351.223 133.088 351.793 133.661 351.498 134.173L347.618 140.916C347.466 141.18 347.178 141.337 346.874 141.322L339.739 140.961C339.154 140.931 338.976 140.151 339.492 139.872C340.027 139.582 340.55 139.291 341.072 139.001C340.578 138.013 339.713 136.531 338.849 135.049L345.147 128.132Z",
    fill: "#001F23"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M352.432 161.849H345.146L345.081 164.118C345.064 164.703 344.29 164.898 343.998 164.391L340.084 157.587C339.932 157.323 339.941 156.995 340.107 156.74L343.967 150.814C344.285 150.325 345.044 150.559 345.033 151.142C345.022 151.716 345.022 152.286 345.022 152.833C346.133 152.956 347.863 152.956 349.591 152.956L352.432 161.849Z",
    fill: "#001F23"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M319.581 151.227L323.162 144.928L321.31 143.778C320.814 143.47 321.032 142.705 321.616 142.705H329.46C329.764 142.705 330.042 142.875 330.181 143.145L333.464 149.529C333.736 150.057 333.133 150.603 332.633 150.282C332.11 149.946 331.588 149.598 331.065 149.25C330.448 150.238 329.583 151.72 328.718 153.325L319.581 151.227Z",
    fill: "#001F23"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_763_11589",
    x1: 87.7387,
    y1: -24.136,
    x2: 178.89,
    y2: 174.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_763_11589",
    x1: 186.788,
    y1: 32.8135,
    x2: 58.8502,
    y2: 91.9854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_763_11589",
    x1: 215.284,
    y1: 22.1318,
    x2: 139.429,
    y2: 56.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_763_11589",
    x1: 183.983,
    y1: 199.649,
    x2: 158.593,
    y2: 200.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_763_11589",
    x1: 197.241,
    y1: 190.711,
    x2: 177.214,
    y2: 214.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_763_11589",
    x1: 181.037,
    y1: 147.659,
    x2: 161.389,
    y2: 149.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_763_11589",
    x1: 227.473,
    y1: 198.201,
    x2: 179.738,
    y2: 243.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_763_11589",
    x1: 180.553,
    y1: 198.201,
    x2: 132.818,
    y2: 243.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_763_11589",
    x1: 121.782,
    y1: 155.156,
    x2: 89.1438,
    y2: 156.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_763_11589",
    x1: 138.825,
    y1: 143.665,
    x2: 113.074,
    y2: 174.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_763_11589",
    x1: 117.995,
    y1: 88.3223,
    x2: 92.7362,
    y2: 91.1464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_763_11589",
    x1: 177.688,
    y1: 153.295,
    x2: 116.323,
    y2: 211.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_763_11589",
    x1: 117.372,
    y1: 153.295,
    x2: 56.0074,
    y2: 211.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_763_11589",
    x1: 400.762,
    y1: 103.066,
    x2: 123.949,
    y2: 227.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_763_11589",
    x1: 313.826,
    y1: 127.311,
    x2: 301.507,
    y2: 145.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_763_11589",
    x1: 315.794,
    y1: 142.464,
    x2: 304.102,
    y2: 161.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_763_11589",
    x1: 316.478,
    y1: 157.616,
    x2: 304.159,
    y2: 175.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_763_11589",
    x1: 318.753,
    y1: 172.77,
    x2: 307.37,
    y2: 192.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_763_11589",
    x1: 350.725,
    y1: 187.923,
    x2: 343.679,
    y2: 212.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_763_11589",
    x1: 353.387,
    y1: 203.075,
    x2: 346.987,
    y2: 227.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_763_11589",
    x1: 353.752,
    y1: 218.229,
    x2: 346.898,
    y2: 242.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_763_11589",
    x1: 301.049,
    y1: 88.3223,
    x2: 260.785,
    y2: 131.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_763_11589",
    x1: 305.208,
    y1: 108.409,
    x2: 301.724,
    y2: 126.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_763_11589",
    x1: 301.718,
    y1: 279.661,
    x2: 287.242,
    y2: 285.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_763_11589",
    x1: 331.394,
    y1: 276.163,
    x2: 315.504,
    y2: 281.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_763_11589",
    x1: 353.512,
    y1: 248.627,
    x2: 323.215,
    y2: 295.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_763_11589",
    x1: 337.449,
    y1: 241.236,
    x2: 324.57,
    y2: 245.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_763_11589",
    x1: 353.248,
    y1: 249.036,
    x2: 340.1,
    y2: 260.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_763_11589",
    x1: 268.653,
    y1: 130.028,
    x2: 208.37,
    y2: 168.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_763_11589",
    x1: 245.538,
    y1: 150.614,
    x2: 213.529,
    y2: 174.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_763_11589",
    x1: 267.42,
    y1: 130.028,
    x2: 210.561,
    y2: 162.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_763_11589",
    x1: 244.305,
    y1: 150.614,
    x2: 214.747,
    y2: 168.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_763_11589",
    x1: 270.84,
    y1: 179.019,
    x2: 228.441,
    y2: 220.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_763_11589",
    x1: 274.152,
    y1: 189.548,
    x2: 216.276,
    y2: 232.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_763_11589",
    x1: 267.433,
    y1: 204.726,
    x2: 239.877,
    y2: 219.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_763_11589",
    x1: 265.698,
    y1: 184.14,
    x2: 236.14,
    y2: 202.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_763_11589",
    x1: 248.871,
    y1: 189.548,
    x2: 212.78,
    y2: 202.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_763_11589",
    x1: 241.447,
    y1: 179.018,
    x2: 224.242,
    y2: 191.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_763_11589",
    x1: 376.064,
    y1: 346.556,
    x2: 355.304,
    y2: 365.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_763_11589",
    x1: 420.1,
    y1: 347.802,
    x2: 403.001,
    y2: 367.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_763_11589",
    x1: 399.619,
    y1: 151.984,
    x2: 355.968,
    y2: 175.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_763_11589",
    x1: 401.242,
    y1: 139.273,
    x2: 400.619,
    y2: 141.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_763_11589",
    x1: 428.03,
    y1: 151.838,
    x2: 378.923,
    y2: 162.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_763_11589",
    x1: 401.856,
    y1: 150.575,
    x2: 361.737,
    y2: 157.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_763_11589",
    x1: 431.308,
    y1: 155.353,
    x2: 384.433,
    y2: 172.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_763_11589",
    x1: 349.791,
    y1: 128.132,
    x2: 324.3,
    y2: 145.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_763_11589",
    x1: 362.075,
    y1: 140.358,
    x2: 337.334,
    y2: 149.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_763_11589",
    x1: 342.903,
    y1: 151.226,
    x2: 323.581,
    y2: 170.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_763_11589",
    x1: 354.77,
    y1: 128.132,
    x2: 334.876,
    y2: 138.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_763_11589",
    x1: 355.554,
    y1: 150.549,
    x2: 335.325,
    y2: 160.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_763_11589",
    x1: 337.028,
    y1: 142.705,
    x2: 318.769,
    y2: 156.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendations);
export default __webpack_public_path__ + "static/media/recommendations.340a73514764a9e1e423386f9b8bd6cd.svg";
export { ForwardRef as ReactComponent };